export const formatNumberWithSpaces = (number: number) => {
    let numberString = number.toString();
    let [integerPart, decimalPart] = numberString.split('.');
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
}

export const shortNumberForm = (number: number, pricision = 2) => {
    if (number >= 1_000_000_000)
        return (number / 1_000_000_000).toFixed(pricision) + 'B';
    else if (number >= 1_000_000)
        return (number / 1_000_000).toFixed(pricision) + 'M';
    else if (number >= 1_000)
        return (number / 1_000).toFixed(pricision) + 'K';

    return number.toString();
}

export const countDecimalPlaces = (num: number) => {
    if (!isFinite(num))
        return 0;

    let str = num.toString();
    
    if (str.includes('e')) {
        const [base, exponent] = str.split('e');
        const exp = parseInt(exponent);
        
        if (exp < 0) {
            return Math.abs(exp) + (base.includes('.') ? base.split('.')[1].length : 0);
        } else {
            str = num.toFixed(20);
        }
    }
    
    if (str.includes('.')) {
        const decimalPart = str.split('.')[1].replace(/0+$/, '');
        return decimalPart.length;
    }
    
    return 0;
}